import React, { useRef, useState } from 'react';
import './OpalMultipleTagInput.css';
import TauriImage from '../TauriImage/TauriImage';

const OpalMultipleTagInput = ({
    tags,
    setTags,
    addTag,
    removeTag,
    inputValue,
    setInputValue,
    items = [],
    onMouseEnter,
    onMouseLeave,
    onMouseOver,
    onMouseOut,
    onMouseDown,
    onMouseUp,
    onMouseMove,
    onChange
}) => {

    const [showMenu, setShowMenu] = useState(false);
    const wrapperRef = useRef(null);

    const handleClickOutside = (e) => {
        if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
            setShowMenu(false);
        }
    };

    React.useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleKeyDown = (event) => {
        if (event.key === 'Backspace' && !inputValue && tags.length > 0) {
            removeTag(tags.slice(0, -1));
        }
    };

    const handleRemoveTag = (index) => {
        removeTag(tags.filter((_, i) => i !== index));
    };

    const filteredItems = items.filter(
        item =>
            item.name.toLowerCase().includes(inputValue.toLowerCase()) &&
            !tags.some(tag => tag.id === item.id)
    );

    return (
        <div
            className="opal-tag-input-wrapper" ref={wrapperRef}>
            <div className="opal-tag-input-container">
                {tags.map((tag, index) => (
                    <div key={index} className="tag">
                        {tag.name}
                        <TauriImage
                            localImage={"/Images/carbon--close-outline.svg"}
                            className={"remove-tag"}
                            onClick={() => handleRemoveTag(index)}
                            alt='tag'
                            color={"#C2C0C0"}
                        />
                    </div>
                ))}
                <input
                    type="text"
                    value={inputValue}
                    onChange={(e) => {
                        setInputValue(e.target.value);
                        onChange?.(e);
                    }}
                    onFocus={() => setShowMenu(true)}
                    onKeyDown={handleKeyDown}
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                    onMouseOver={onMouseOver}
                    onMouseOut={onMouseOut}
                    onMouseDown={onMouseDown}
                    onMouseUp={onMouseUp}
                    onMouseMove={onMouseMove}
                    className="opal-tag-input"
                />
            </div>

            {showMenu && (
                <div className="opal-tag-dropdown">
                    {filteredItems.map((item, idx) => (
                        <div
                            key={idx}
                            className="opal-tag-dropdown-item"
                            onClick={() => {
                                addTag(item);
                                setInputValue('');
                                setShowMenu(false);
                            }}
                        >
                            {item.name}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default OpalMultipleTagInput;
